export default __webpack_public_path__ + "static/media/ci.4055703a.png";